var map = {
	"./Alessandro.png": 515,
	"./Benedetta.png": 516,
	"./Diano.png": 517,
	"./Giorgia.png": 518,
	"./Ortu.png": 519,
	"./Project-1.png": 520,
	"./Project-2.png": 521,
	"./Project-3.png": 522,
	"./Shlomo.png": 523,
	"./Vivi.png": 524,
	"./adel.png": 525,
	"./arthouse.webp": 526,
	"./banner-mob.png": 373,
	"./banner.png": 374,
	"./carolina.png": 527,
	"./levi.jpg": 528,
	"./levi.png": 529,
	"./logo.png": 352,
	"./milano-logo.png": 530,
	"./milano-logo.svg": 366,
	"./new-logo.svg": 531,
	"./partner.png": 532,
	"./partner_1.png": 354,
	"./partner_2.png": 355,
	"./partner_3.png": 356,
	"./partner_4.png": 357,
	"./partner_5.png": 358,
	"./partner_6.png": 359,
	"./partner_7.png": 360,
	"./partner_8.png": 361,
	"./partners.png": 533,
	"./rove.webp": 534,
	"./udo.png": 535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 353;